import { Link } from "react-router-dom";
import { LoginForm } from "../components/LoginForm";
import { SocialButtons } from "../components/SocialButtons";
import { Logo } from "@/components/ui/logo";
import { Card } from "@/components/ui/card";

export function LoginPage() {
  return (
    <Card className="p-8 shadow-card border-border/60">
      <div className="mb-7 flex justify-center">
        <Logo />
      </div>

      <LoginForm />

      <div className="my-6" />

      <SocialButtons />

      <p className="mt-6 text-center text-sm text-ink-muted">
        Ainda não tem conta?{" "}
        <Link to="/register" className="font-semibold text-brand-600 hover:underline">
          Cadastre sua imobiliária
        </Link>
      </p>

      <div className="mt-6 border-t border-border/40 pt-6 text-center">
        <p className="text-xs text-ink-soft">
          Dificuldades no acesso? <a href="#" className="font-semibold text-brand-600 hover:underline">Fale com o suporte</a>
        </p>
      </div>
    </Card>
  );
}
